module.exports = __webpack_public_path__ + "static/media/login-image.df396d17.png";